<!-- <div *ngIf="url.deleteAll" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
  <div class="well well-lg card card-block card-header mb-4">
    <button style="width: 200px;" class="btn btn-lg btn-danger"
      (click)="deleteSwal.fire()">{{'table.deleteSeleted' | translate}}</button>
  </div>
</div> -->

<!-- <div class="delete-all" *ngIf="url && url.deleteAll">
  <div [ngClass]="{ hide: isCollapsed }" class="well well-lg card card-block card-header mb-4">
    <button style="width: 200px;" class="btn btn-lg btn-danger" (click)="deleteSwal.fire()">
      {{ 'table.deleteSeleted' | translate }}
    </button>
  </div>
</div>

<div class="add-header">
  <div class="btns-container">
    <button *ngIf="options.add" type="button" (click)="goToAddPage()" class="btn btn-primary create-btn">
      {{ 'common.add' | translate }} <i class="fas fa-plus-circle"></i>
    </button>
  </div>
</div> -->

<div class="table-with-search">
  <!-- <form style="width: 100%" *ngIf="options.globalSearch" [formGroup]="globalSearch">
    <div class="search-btn-wrap">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupPrepend">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <input
          type="text"
          class="form-control form-control-lg"
          id="validationCustomUsername"
          [placeholder]="'common.search' | translate"
          aria-describedby="inputGroupPrepend"
          formControlName="search"
        />
      </div>
    </div>
  </form> -->
  <div fxFlex fxLayout="column" class="core-list">
    <app-list
      [url]="url"
      [columnsI]="columns"
      [actions]="actions"
      [id]="id"
      [data]="data"
      [options]="options"
      [selectedData]="selectedData"
      (selected)="getSelected($event)"
    ></app-list>
  </div>
</div>
